import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui';
import { AuthAlert, AuthLayout } from './auth/AuthLayout';

export function PendingApproval() {
  const { logout } = useAuth();

  return (
    <AuthLayout title="Awaiting clearance">
      <AuthAlert tone="warning">
        Your account is registered and waiting for an administrator to approve it.
        You can use the console as soon as it is approved.
      </AuthAlert>
      <Button variant="secondary" onClick={logout} style={{ width: '100%' }}>Sign out</Button>
    </AuthLayout>
  );
}
